import { EquipmentCertificateClient } from '@frontend/certificate/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useEquipmentCertificate:request': CustomEvent<string>;
    }
}

const REQUEST_EQUIPMENT_CERTIFICATE_EVENT = 'useEquipmentCertificate:request';
const STORAGE_KEY = 'EQP_CERT_REQ';

export function equipmentCertificateRequest(certificateId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_EQUIPMENT_CERTIFICATE_EVENT, { detail: certificateId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function EquipmentCertificateResolver(props: Props) {
    useResolver(
        STORAGE_KEY,
        REQUEST_EQUIPMENT_CERTIFICATE_EVENT,
        EntityType.EQUIPMENT_CERTIFICATE,
        (ids) => EquipmentCertificateClient.resolveEquipmentCertificates(ids),
        props.dispatch
    );
    return <></>;
}
